import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule, ErrorHandler } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FullLayoutComponent } from './containers/full-layout/full-layout.component';
import { CoreModule } from './core/core.module';
import { AppConfigService } from './core/config/config.service';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { CustomersInvoicePrintComponent } from './modules/customers/components/customers-invoice-print/customers-invoice-print.component';
import { SalesPrintComponent } from './modules/reports/components/sales-print/sales-print.component';
import { NotificationModule } from './modules/notification/notification.module';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    AppComponent,
    FullLayoutComponent,
    CustomersInvoicePrintComponent,
    SalesPrintComponent,
  ],

  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    PerfectScrollbarModule,
    SharedModule,
    NotificationModule
  ],

  providers: [
    GoogleAnalyticsService,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },

    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(trace: Sentry.TraceService) { }
}
